import { FAQContent } from "../../../domain/faq/FAQContent";
import { FAQTitle } from "../../../domain/faq/FAQTitle";
import { ApiPaths } from "../../api/ApiPaths";
import { ApiRequest } from "../../api/ApiRequest";

export type GetFAQListSuccessResponseType = {
    faqList: [{
        id: string,
        title: string,
        content: string,
        createdTime: string
    }],
    // API処理結果判別用：OK->undefined、NG->ErrorResponseType
    error: undefined
}

export type RegisterFAQRequestType = {
    title: FAQTitle,
    content: FAQContent,
};

export async function getFAQList(): Promise<GetFAQListSuccessResponseType> {
    return await ApiRequest.get(
        ApiPaths.faq.list,
        {},
        () => {},
        () => {});
}

export async function registerFAQ(
    body: RegisterFAQRequestType    
) {
    return await ApiRequest.post(
        ApiPaths.admin.faqRegister,
        {},
        convertBody(body),
        () => {},
        () => {}
    );
}

export async function updateFAQ(
    faqId: string,
    body: RegisterFAQRequestType    
) {
    return await ApiRequest.post(
        ApiPaths.admin.faqUpdate.replace(/\{faqId\}/g, faqId),
        {},
        convertBody(body),
        () => {},
        () => {}
    );
}

export async function deleteFAQ(
    faqId: string
) {
    return await ApiRequest.delete(
        ApiPaths.admin.faqUpdate.replace(/\{faqId\}/g, faqId),
        {},
        () => {},
        () => {});
}

const convertBody = (body: RegisterFAQRequestType) => {
    return {
        title: body.title.value,
        content: body.content.value
    };
};
